module.exports = __webpack_public_path__ + "fonts/BrandonGrotesque-Medium.ef4fddb0.ttf";